<template>
  <ul class="te-side-menu co-container-sm mx-auto list-none p-0">
    <li class="border-b border-co-gray-300">
      <a
        class="co-display-12 block p-3 text-co-gray-700 no-underline"
        href="https://tokyoitschool.jp/contact/common/input/"
        :class="{ 'bg-co-gray-300 font-bold': isLinkActive('https://tokyoitschool.jp/contact/common/input/') }"
        target="_blank"
        >
        お問い合わせ
      </a>
    </li>
    <li class="border-b border-co-gray-300">
      <a
        class="co-display-12 block p-3 text-co-gray-700 no-underline"
        href="https://www.3sss.co.jp/about/index.html"
        :class="{ 'bg-co-gray-300 font-bold': isLinkActive('https://www.3sss.co.jp/about/index.html') }"
        target="_blank"
      >
        運営会社
      </a>
    </li>
    <li class="border-b border-co-gray-300">
      <a
        class="co-display-12 block p-3 text-co-gray-700 no-underline"
        href="/biz/terms"
        :class="{ 'bg-co-gray-300 font-bold': isLinkActive('/biz/terms') }"
      >
        利用規約
      </a>
    </li>
    <li class="border-b border-co-gray-300">
      <a
        class="co-display-12 block p-3 text-co-gray-700 no-underline"
        href="https://www.3sss.co.jp/privacy-policy/"
        :class="{ 'bg-co-gray-300 font-bold': isLinkActive('https://www.3sss.co.jp/privacy-policy/') }"
        target="_blank"
      >
        個人情報保護基本方針
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useLinkActive } from '~/composables/useLinkActive/useLinkActive'

const { isLinkActive } = useLinkActive()
</script>

<style scoped>
.te-side-menu a {
  line-height: 1.4286;
}

@media (max-width: 767.98px) {
  .te-side-menu a {
    font-size: 0.75rem;
  }
}

.te-side-menu a:hover {
  color: #333;
  background: #ccc;
}
</style>
